import { gqlApi } from '../../../../../modules/shared/shared.global-service';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';

export async function getServiceId(folderId: number): Promise<{ serviceId?: number, personId?: number }> {
    if (!folderId) return {};
    const folder = await gqlApi.getFolders(FilterBuilder.filterById(folderId), 'serviceId personId');

    return folder?.items?.[0] || {};
}
